import { render } from "./SecondChoiceCallPage.vue?vue&type=template&id=3a53d702&scoped=true"
import script from "./SecondChoiceCallPage.vue?vue&type=script&lang=js"
export * from "./SecondChoiceCallPage.vue?vue&type=script&lang=js"

import "./SecondChoiceCallPage.vue?vue&type=style&index=0&id=3a53d702&lang=scss&scoped=true"

import exportComponent from "/home/forge/vienaiespeja.on-forge.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a53d702"]])

export default __exports__